module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popover-box', {
    ref: "popover",
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction,
      "colorTheme": _vm.colorTheme
    }
  }, [_vm._l((_vm.notifications), function(n) {
    return [_c('notification', {
      key: n.id,
      attrs: {
        "notification": n,
        "actionEngine": _vm.actionEngine,
        "dismiss": _vm.dismiss
      },
      on: {
        "delete": _vm.deleteNotification
      }
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25d31304","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/popover/builderComponents/NotificationPopover.vue
// module id = 2026
// module chunks = 0